import type { State } from '../../typings'

export const openDeleteDialogProducer = (state: State, payload: string) => ({
  ...state,
  deleteDialogOpened: true,
  underDeletion: payload,
})
